import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import bem from '@lib/bem'
import { withPluginSlot } from '@plugins/index'

export interface PassengersListLabelProps {
  passenger: Passenger.Type
  isMaxAge: boolean
}

const PassengersListLabel = ({ passenger, isMaxAge }: PassengersListLabelProps) => {
  const { t } = useTranslation()

  const description = useMemo(() => {
    const { minAge, maxAge, description } = passenger
    if (description?.length > 0) return description
    if (minAge == null && maxAge == null) return null
    if (minAge === 0 && maxAge == 99) return t('passengers.anyAge')
    if (minAge === 0) return t('passengers.under', { maxAge: isMaxAge ? maxAge : maxAge + 1, defaultValue: '' })

    return isMaxAge
      ? t('passengers.over', { minAge, defaultValue: '' })
      : t('passengers.ageRange', { minAge, maxAge, defaultValue: '' })
  }, [isMaxAge, passenger, t])

  return (
    <>
      <div className={bem('passenger-counters', 'name')}>{t(`searchBar.passengers.codes.${passenger.code}`)}</div>
      <div className={bem('passenger-counters', 'description')}>{description}</div>
    </>
  )
}

export default withPluginSlot(PassengersListLabel, 'PassengersListLabel')
